import React from 'react'
import { withStyles, Typography, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import TextInput from 'components/TextInput';
import RadioButton from '../../components/RadioButton';
import INPUT_TYPE from "constants/INPUT_TYPE";
import getObjectValue from "libs/getObjectValue";

const style = theme => ({
	root: {
		'&>*': {
			marginRight: theme.spacing(1),
		}
	},
	input: {
		width: theme.components.input.criteria.width,
	}
});

function BaseVariant({
	classes,
	index,
	formikProps,
	disableMin = false,
	disableMax = false,
	isLast = false,
	disabled
}) {
	const criterionId = 'intervalList';

	const pointsId = `${criterionId}.${index}.value`;
	const minId = `${criterionId}.${index}.from`;
	const maxId = `${criterionId}.${index}.to`;
	const minRadioId = `${criterionId}.${index}.fromInclusive`;
	const maxRadioId = `${criterionId}.${index}.toInclusive`;
	const nextMinRadioId = `${criterionId}.${index + 1}.fromInclusive`;
	const editable = getObjectValue('_editable', formikProps.values, false);

	return (
		<GridBlock alignItems='center' className={classes.root}>
			<Tooltip title={Tr('inclusive_from')} placement='top'>
				<div>
					<RadioButton
						hide={disableMin}
						id={minRadioId}
						formikProps={formikProps}
						disabled={!editable || disabled}
					/>
				</div>
			</Tooltip>
			<TextInput
				id={minId}
				className={classes.input}
				formikProps={formikProps}
				noError
				disabled={disableMin || disabled}
				placeholder={Tr('from')}
				type={INPUT_TYPE.NUMBER_19}
			/>
			<Tooltip title={Tr('inclusive_to')} placement='top'>
				<div>
					<RadioButton
						hide={disableMax}
						id={maxRadioId}
						pairId={isLast ? undefined : nextMinRadioId}
						formikProps={formikProps}
						disabled={!editable || disabled}
					/>
				</div>
			</Tooltip>
			<TextInput
				id={maxId}
				className={classes.input}
				formikProps={formikProps}
				noError
				disabled={disableMax || disabled}
				placeholder={Tr('to')}
				type={INPUT_TYPE.NUMBER_19}
			/>
			<Typography variant='body1'>
				{Tr('admit')}
			</Typography>
			<TextInput
				id={pointsId}
				className={classes.input}
				formikProps={formikProps}
				type={INPUT_TYPE.NUMBER_19}
				noError
				disabled={disabled}
			/>
			<Typography variant='body1'>
				{Tr('points')}.
			</Typography>
		</GridBlock>
	)
}

BaseVariant.propTypes = {
	classes: PropTypes.any,
	children: PropTypes.any,
};

BaseVariant.defaultProps = {
};

export default withStyles(style)(BaseVariant);